import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson thành lập London Rubber Company và bán bao cao su nhập khẩu',
		},
		{
			year: 1929,
			description: 'London Rubber Company (LRC) đăng ký thương hiệu Durex',
		},
		{
			year: '1950s',
			description: 'Durex cho ra mắt bao cao su bôi trơn đầu tiên',
		},
		{
			year: 1953,
			description: 'Durex là thương hiệu đầu tiên phát triển và áp dụng kiểm tra điện tử',
		},
		{
			year: '1960',
			description: 'Durex cho ra mắt bao cao su với hình dạng đúng với giải phẫu học',
		},
		{
			year: '1970s',
			description: 'Durex trở thành thương hiệu bao cao su đầu tiên quảng cáo rộng rãi tại nhiều quốc gia',
		},
		{
			year: '1990s',
			description: 'Durex là thương hiệu bao cao su đầu tiên dùng “con dấu toàn cầu” làm tiêu chuẩn',
		},
		{
			year: 1995,
			description: 'Durex cho ra mắt dòng bao cao su có màu và có vị',
		},
		{
			year: 1996,
			description: 'Durex trở thành thương hiệu bao cao su đầu tiên thiết lập trang web. Hiện nay, Durex có đến 42 trang web tại các quốc gia và vùng lãnh thổ',
		},
		{
			year: 1997,
			description: 'Durex ra mắt bao cao su sử dụng cao su nhân tạo (không có latex). Chất liệu do Durex phát triển không gây dị ứng cho người dùng, mềm và có độ co dãn tốt hơn so với cao su tự nhiên',
		},
		{
			year: 1998,
			description: 'Durex là thương hiệu bao cao su đầu tiên thực hiện khảo sát và công bố kết quả sức khỏe tình dục trên toàn thế giới',
		},
		{
			year: 2001,
			description: 'Durex trình làng Pleasuremax – Dòng sản phẩm kết hợp giữa gân và gai',
		},
		{
			year: 2003,
			description: 'Durex giới thiệu dòng Gel bôi trơn Play đầy ấn tượng',
		},
		{
			year: 2005,
			description: 'Durex phát hành báo cáo “Face of Global Sex” về hành vi tình dục nhằm phổ biến thông tin cho học giả và các nhà chính sách',
		},
		{
			year: 2008,
			description: 'Để giới trẻ hiểu rõ hơn về tình dục an toàn, Durex khuyến khích các bạn trẻ độ tuổi từ 16 – 24 thiết kế những tấm áp phích độc đáo về sức khỏe tình dục',
		},
		{
			year: 2009,
			description: 'Durex kỷ niệm năm hoạt động thứ 80',
		},
		{
			year: 2010,
			description: 'Durex quyên góp 220,000 bao cao su để hưởng ứng chiến dịch “Condomized!” khởi xướng bởi Quỹ Hiệp Hội Dân Số Thế Giới tại Hội Nghị AIDS Quốc Tế tại Vienna',
		},
		{
			year: 2010,
			description: 'Durex được Reckitt Benckiser mua lại',
		},
		{
			year: 2010,
			description: 'Durex trình làng Performa – Dòng bao cao su chứa gel bôi trơn với 5% Benzocaine giúp cuộc yêu thêm dài và mãnh liệt',
		},
		{
			year: 2019,
			description: 'Durex đánh dấu cột mốc 90 năm hoạt động!',
		},
	]
}